export enum TicketProperty {
    AssignedUser = 1,
    EntityType = 2,
    // EntityTypeId = 7,
    Center = 7,
    TierLevel = 3,
    TicketStatus = 4,
    Group = 5,
    Urgency = 6,
    TicketType = 8
}